import {useQuery} from "@tanstack/react-query";

import {useStoredMe} from "@/src/modules/core/store/me";

import {HELP_STALE_TIME_MS} from "../lib/help-cache";
import {helpService} from "../services";

export default function useHelpDomain(domain: string, enabled = true) {
  const me = useStoredMe();
  const userId = me?.user_id ?? 0;

  return useQuery({
    queryKey: ["help", "bundle", userId, domain],
    queryFn: () => helpService.getDomain(userId, domain),
    enabled: enabled && userId > 0 && Boolean(domain),
    staleTime: HELP_STALE_TIME_MS,
    retry: false,
  });
}
